<script setup>
import { useRoute, useRouter } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { GetOrganisation } from "@/services/organisationService.js";
import { GetApp } from "@/services/appService.js";
import { getContext } from "@/services/context.js";
import { GetPanels } from "@/services/panelsService.js";
import AppLayout from "@/layouts/AppLayout.vue";
import { Label } from "@/components/ui/label/index.js";
import { Input } from "@/components/ui/input/index.js";
import { Button } from "@/components/ui/button/index.js";
import { Copy } from "lucide-vue-next";

const route = useRoute();
const router = useRouter();

const organisation = ref(null);
const app = ref(null);
const panels = ref(null);
const isLoading = ref(true);
const hasApps = computed(() => app.value && app.value.length > 0);
const hasPanels = computed(() => panels.value && panels.value.length > 0);

const appKey = ref('');

onMounted(async () => {
  const context = getContext(route);

  // Load data in parallel
  const [orgData, appData, panelsData] = await Promise.all([
    GetOrganisation(context),
    GetApp(context),
    GetPanels(context)
  ]);

  organisation.value = orgData;
  app.value = appData;
  panels.value = panelsData;

  appKey.value = app.value.appKey;

  isLoading.value = false;
});

function copyToken() {
  navigator.clipboard.writeText(appKey.value);
}
</script>

<template>
  <AppLayout :organisation="organisation" :app="app">
    <div>
      <Label for="name">App key</Label>
      <div class="flex gap-2 items-center">
        <Input id="appKey" type="text" required v-model="appKey" readonly />
        <Button @click="copyToken" variant="ghost" size="sm">
          <Copy />
        </Button>
      </div>
    </div>
  </AppLayout>
</template>

<style scoped></style>